module.exports = __webpack_public_path__ + "static/media/USSF-90-Min-Display-Medium.f29354a3.ttf";